import React from "react";
import { Box, Typography } from "@mui/material";
import imgbg from "../../assets/treeoverlay.png";
const TextSection = () => {
  return (
    <Box sx={styles.pageContainer}>
      <Box component="img" src={imgbg} alt="Decorative" sx={styles.image} />
      <Box sx={styles.textContent}>
        <Typography sx={styles.pageText}>
          Experience a tranquil escape with our collection of three{" "}
          <Box component="span" sx={styles.earthenSuite}>
            Bali-inspired luxury suites{" "}
          </Box>
          just 50km from Bangalore - a perfect destination for refreshing holidays.
        </Typography>
      </Box>
    </Box>
  );
};

const styles = {
  pageContainer: {
    position: "relative",
    width: "100%",

    height: { xs: "475px", sm: "680px" },
    backgroundImage: "url('/assets/BG.png')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

  },
  textContent: {
    position: "relative",
    width: "80%",
    maxWidth: "900px",
    textAlign: "center",
    marginTop: "20px",
  },
  pageText: {
    fontFamily: "'Playfair Display', serif",
    fontWeight: 200,

    fontSize: {
      xs: "26px",
      sm: "36px",
    },
    lineHeight: {
      xs: "28px",
      sm: "50px",
    },
    letterSpacing: "0.01em",
    textAlign: "center",
    color: "#4C4C4C",
  },
  earthenSuite: {
    fontFamily: "'Playfair Display', serif",
    fontWeight: 500,
    fontStyle: "italic",
    fontSize: {
      xs: "26px",
      sm: "36px",
    },
    lineHeight: {
      xs: "28px",
      sm: "50px",
    },
    letterSpacing: "0.01em",
    color: "#FA8F21",
   
  },
  image: {
    position: "absolute",
    width: "auto",
    maxWidth: "164px",
    height: "492px",
    bottom: "0px",
    left: "0px",
    zIndex: 1,
    marginBottom: "20px",
  },
};

export default TextSection;
